import ordinal from "ordinal";
import moment from "moment";

export default {
  filters: {
    niceDate(dateString) {
      if (!dateString) {
        return "";
      }

      const d = moment(dateString).locale("en-NZ");
      const day = d.format("dddd");
      const date = ordinal(parseInt(d.format("D"), 10));
      const month = d.format("MMMM");
      const year = parseInt(d.format("YYYY"), 10);
      const time = d.format("HH:mm");

      return `${day} ${date} ${month} ${year}, ${time}`;
    },

    formatDate(datetime) {
      return moment(datetime).format("MMM D, YYYY hh:mm A");
    }
  }
};
